import ProtectedRoute from './protectedRoute.component';

export default ProtectedRoute;